import { render, staticRenderFns } from "./cash-margin-list-member.vue?vue&type=template&id=1cc945cc&scoped=true&"
import script from "./cash-margin-list-member.vue?vue&type=script&lang=js&"
export * from "./cash-margin-list-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc945cc",
  null
  
)

export default component.exports